export const styles = {
    rotatingArrow: (rotate: boolean) => ({
        transform: rotate ? 'rotateX(180deg)' : 'rotateX(0deg)', transition: 'transform 0.3s'
    }),
    popoverItem: {
        maxH: 20,
        p: 1.5,
        gap: 1,
        width: "full",
        display: "flex",
        cursor: "pointer",
        borderRadius: 8,
        alignItems: "center",
        _hover: {
            background: 'rgba(0, 0, 0, 0.08)',
        }
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        gap: 3,
        px: 2,
        py: 2.5,
        w: "full",
        borderRadius: 8,
        textAlign: "left" as const,
        transition: "background 0.15s",
        _hover: {
            bg: "blackAlpha.50",
        },
    },
};
